import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

export const formatTimer = (date: string) => {
  return dayjs.utc(date).format("HH:mm:ss");
};
